import { Mobile, Carousel_CoreInit, Accordion } from './core'
import VH from './plugins/vh'
import './modules/header'
import './modules/expanding'
import './modules/audio-player'
import './modules/balado'
import './plugins/google-map'
import './plugins/newsletter-form'

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    scroller: $(window).ScrollEvents()
  }

  /* Viewport height */
  VH.init()

  /* Header */
  $('.header').each(function() {
    $(this).Header()
  })

  /* Carousel */
  Carousel_CoreInit([
    {
      classSelector: 'carousel--postitem__community-member',
      swiperOptions: {
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 2,
          },
          768: {
            centerInsufficientSlides: true,
          },
        },
      },
    },
    {
      classSelector: 'carousel--postitem__product',
      swiperOptions: {
        breakpoints: {
          0: {
            spaceBetween: 16,
            slidesPerView: 2,
          },
        },
      },
    },
    {
      classSelector: 'carousel--custom',
      swiperOptions: {
        breakpoints: {
          0: {
            spaceBetween: 16,
          },
          768 : {
            spaceBetween: 0,
          },
        },
      },
    },
    {
      classSelector: 'carousel--style--gallery',
      swiperOptions: {
        0: {
          spaceBetween: 16,
        },
      },
    },
  ])

  /* Fixed content */
  $('.product-info__wrapper').each(function() {
    $(this).FixedContent({
      bottomBlocker: $('.product__related'),
      limitFromTop: 24,
    })
  })

  /* Accordions */
  Accordion.init()
  $('.product .accordion__header').on('click', function() {
    if (!$.mlmi.mobile.isMobile) {
      if ($(this).attr('aria-expanded') === 'false') {
        let gallery = $('.product__gallery'),
        wrapper = $('.product-info__wrapper'),
        info = $('.product__information'),
        panel = $('.product .accordion__panel'),
        bottom = (gallery.offset().top + gallery.outerHeight(false)) - (wrapper.offset().top + wrapper.outerHeight(false) + parseFloat(info.css('padding-top')))
        if (bottom < panel.data('max-height')) {
          let targetTop = $(window).scrollTop() - (panel.data('max-height') - bottom)
          $('html, body').scrollTo(targetTop, 200, 9999, 'easeInOutQuart')
        }
      }
    }
  });

  /* Expanding */
  $('.page-section.expanding-start').each(function() {
    $(this).Expanding()
  })

  /* Audio player */
  $('.audio-player').each(function() {
    $(this).AudioPlayer()
  })

  /* Balado */
  $('.balado').each(function() {
    $(this).Balado()
  })

  /* Galerie */
  $('a[data-fancybox="galerie"]').fancybox({
    lang: 'fr',
    buttons: ['close'],
    loop: true,
    hash: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    i18n: {
      fr: {
        CLOSE: 'Fermer',
        NEXT: 'Suivant',
        PREV: 'Précédant',
      },
    },
    btnTpl: {
      close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"></button>',
      arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"></button>',
      arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"></button>',
    },
    baseTpl:
    '<div class="fancybox-container" role="dialog" tabindex="-1">' +
      '<div class="fancybox-bg"></div>' +
      '<div class="fancybox-inner">' +
        '<div class="fancybox-toolbar">{{buttons}}</div>' +
        '<div class="fancybox-navigation">{{arrows}}</div>' +
        '<div class="fancybox-stage"></div>' +
        '<div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>' +
      '</div>' +
      '<div class="fancybox-bottom"><div class="container">' +
        '<p class="gallery-title">' + $('h1:first').text() + '</p>' +
        '<div class="fancybox-infobar"><span data-fancybox-index></span>/<span data-fancybox-count></span></div>' +
        '<a class="btn-primary share-page">Partager</a>' +
      '</div></div>' +
    '</div>',
  })

  /* Share */
  $(document).on('click', '.share-page', function() {
    $('.page-share').attr('aria-hidden', 'false')
    $('.page-share__close-btn').on('click', function() {
      $('.page-share').attr('aria-hidden', 'true')
    })
  })

  /* Map */
  $('.contact-map').each(function() {
    $(this).ContactMap()
  })

  /* Forms */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })
})
